import { Box, Button, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../content/Content";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import Slider from "react-slick";
const VideoCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    nav: true,
    nextArrow: <FaAngleRight />,
    prevArrow: <FaAngleLeft />,
    responsive: [
      {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  };
  const VideoSlider = [
    {
      name: "FRX101- introductions ti trade overview",
      time: "08.04.2023",
      img: Img.VideoSlide1,
      bgColor: "rgba(247, 255, 250, 1)",
      duration: "01:30:00",
    },
    {
      name: "FRX101- introductions ti trade overview",
      time: "08.04.2023",
      img: Img.VideoSlide2,
      bgColor: "rgba(247, 255, 250, 1)",
      duration: "01:30:00",
    },
    {
      name: "FRX101- introductions ti trade overview",
      time: "08.04.2023",
      img: Img.VideoSlide3,
      bgColor: "rgba(247, 255, 250, 1)",
      duration: "01:30:00",
    },
    {
      name: "FRX101- introductions ti trade overview",
      time: "08.04.2023",
      img: Img.VideoSlide1,
      bgColor: "rgba(247, 255, 250, 1)",
      duration: "01:30:00",
    },
  ];
  const mobileVideoSlider = VideoSlider.slice(0,3)
  return (
    <VStack w="90%" mx={"auto"} my="50px">
      {/* desktop-version */}
      <Stack w="100%" className="desktop-version">
        <Slider {...settings}>
          {VideoSlider.map((item) => (
            <Box w="100%" p="10px">
              <Stack
                boxShadow=" 0px 0px 9px 0px rgba(0, 0, 0, 0.1)"
                bg="rgba(255, 255, 255, 1)"
                h="209px"
                w="90%"
                margin="auto"
                borderRadius="18px"
              >
                {/* top bar */}
                <Box
                  w="100%"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  px="15px"
                  pt="15px"
                  pb="5px"
                >
                  <Text
                    w="70%"
                    fontFamily="'Roboto', sans-serif"
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(101, 102, 115, 1)"
                  >
                    {item.name}
                  </Text>
                  <Text
                    w="30%"
                    fontFamily="'Roboto', sans-serif"
                    fontSize="12px"
                    fontWeight="400"
                    color="rgba(149, 151, 171, 1)"
                  >
                    {item.time}
                  </Text>
                </Box>
                {/* Video Box */}
                <Box position={'relative'} w="100%" px="15px"
                  pb="10px">
                    <Image src={item.img} alt="photo" w="100%" height={"100%"} />

                    <Stack gap="0" bottom='0' position='absolute' top='0' left={'0'} right={'0'} w="100%" height={'100%'}>
                       <Stack h="33.3%"></Stack> 
                            <Stack h="33.3%" flexDir='row' justifyContent='center' alignItems='center'>
                                <Button bg='transparent' _hover={{bg:'transparent'}}>
                                    <Image src={Img.VideoPlay} />
                                </Button>
                            </Stack> 
                       <Stack h="33.3%" ms='25px'>
                            <Text                  
                    fontFamily="'Roboto', sans-serif"
                    fontSize="12px"
                    fontWeight="400"
                    color="rgba(149, 151, 171, 1)" bg="rgba(255, 255, 255, 1)" p="8px 10px" borderRadius="15px" display={'inline-block'} w="76px" textAlign='center' marginTop={'-4px'}>
                                {item.duration}
                            </Text>
                        </Stack> 
                    </Stack>
                </Box>
              </Stack>
            </Box>
          ))}
        </Slider>
      </Stack>

      {/* mobile- */}
      <Stack w="100%" className="mobile-version">
          {mobileVideoSlider.map((item) => (
            <Box w="100%" p="10px">
              <Stack
                boxShadow=" 0px 0px 9px 0px rgba(0, 0, 0, 0.1)"
                bg="rgba(255, 255, 255, 1)"
                h="auto"
                w="90%"
                margin="auto"
                borderRadius="18px"
              >
                {/* top bar */}
                <Box
                  w="100%"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  px="15px"
                  pt="15px"
                  pb="5px"
                >
                  <Text
                    w="70%"
                    fontFamily="'Roboto', sans-serif"
                    fontSize="14px"
                    fontWeight="500"
                    color="rgba(101, 102, 115, 1)"
                  >
                    {item.name}
                  </Text>
                  <Text
                    w="30%"
                    fontFamily="'Roboto', sans-serif"
                    fontSize="12px"
                    fontWeight="400"
                    color="rgba(149, 151, 171, 1)"
                  >
                    {item.time}
                  </Text>
                </Box>
                {/* Video Box */}
                <Box position={'relative'} w="100%" px="15px"
                  pb="10px">
                    <Image src={item.img} alt="photo" w="100%" height={"100%"} />

                    <Stack gap="0" bottom='0' position='absolute' top='0' left={'0'} right={'0'} w="100%" height={'100%'}>
                       <Stack h="33.3%"></Stack> 
                            <Stack h="33.3%" flexDir='row' justifyContent='center' alignItems='center'>
                                <Button bg='transparent' _hover={{bg:'transparent'}}>
                                    <Image src={Img.VideoPlay} />
                                </Button>
                            </Stack> 
                       <Stack h="33.3%" ms='25px'>
                            <Text                  
                    fontFamily="'Roboto', sans-serif"
                    fontSize="12px"
                    fontWeight="400"
                    color="rgba(149, 151, 171, 1)" bg="rgba(255, 255, 255, 1)" p="8px 10px" borderRadius="15px" display={'inline-block'} w="76px" textAlign='center' marginTop={'-4px'}>
                                {item.duration}
                            </Text>
                        </Stack> 
                    </Stack>
                </Box>
              </Stack>
            </Box>
          ))}
      </Stack>
    </VStack>
  );
};

export default VideoCarousel;
